// extracted by mini-css-extract-plugin
export default {"header":"AccordionHeaderNumeric_header__mTuvh","title":"AccordionHeaderNumeric_title__zX0U2","number":"AccordionHeaderNumeric_number__VttW7"};